import Breadcrumbs from '@components/Breadcrumbs';
import Info from '@components/Info';
import { List, ListItem } from '@components/List';
import Container from '@components/UI/Container';
import Icon from '@components/UI/Icon';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';

import { Navigation } from "@layouts/NavigationV2";
import VersionBanner from '@screens/HelpCenter/Search/VersionBanner';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import Banner from '../Banner';
import Search from '../Search/SearchField';

const Index = ({ posts, category }) => {
    const router = useRouter();

    return (
        <>
            <Navigation
                staticTheme="neutral"
                actionTheme="neutral"
                background='bg-violet-900'
            />

            <div className='help-center'>
                {  <Search
                    isWide={ true }
                />  }

                <Breadcrumbs
                    wrap
                    pathname={ router.asPath.replace(/\?.+/, '') }
                />

                <Container>
    
                    <VersionBanner className={"mb-5"} />
                    
                    <Info
                        mix={ { 'help-center__title': true } }
                    >
                        <Heading
                            tag='h1'
                        >
                            { category?.title }
                        </Heading>

                        <Paragraph
                            tag='p'
                        >
                            { category?.template }
                        </Paragraph>
                    </Info>

                    <List
                        tag='div'
                        mods={ { bordered: true } }
                        gap={ 4 }
                    >
                        { posts?.map(post => (
                            <ListItem
                                key={ post.id }
                                href={ `${ router.query.category }/${ post.slug }` }
                                action
                            >
                                <Icon
                                    name='chevron-right'
                                    size={ 16 }
                                    color='violet-700'
                                />

                                <span>{ post.title }</span>
                            </ListItem>
                        )) }
                    </List>

                    <Banner />
                </Container>
            </div>
        </>
    );
};

Index.propTypes = {
    category: PropTypes.object,
    posts: PropTypes.array
};

export default Index;
